import PropTypes from 'prop-types'
import { Radio } from '../../../../../../common/html/radio'
import { valByKeyWithDot } from '../../../../../../helpers/value'

const ItemRadio = ({
  title,
  isRequire,
  keySetting,
  setting,
  value,
  setValue,
  isI18n,
}) => {
  const activeValue = valByKeyWithDot(setting, keySetting, true)

  const onChange = (val) => {
    setValue(`setting.${keySetting}`, val)
  }

  return (
    <Radio
      title={title}
      isI18n={isI18n}
      isCheckOnClickText
      mlTitle={7}
      disabled={isRequire}
      activeValue={isRequire ? value : activeValue}
      value={value}
      onChange={onChange}
    />
  )
}

ItemRadio.propTypes = {
  title: PropTypes.string.isRequired,
  isRequire: PropTypes.bool,
  keySetting: PropTypes.string.isRequired,
  setting: PropTypes.object,
  value: PropTypes.any,
  setValue: PropTypes.func.isRequired,
  isI18n: PropTypes.bool,
}

ItemRadio.defaultProps = {
  isRequire: false,
}

export default ItemRadio
